export default __webpack_public_path__ + "static/media/pc-mode-footer-new.14a0f4a9.png";